/* tslint:disable:indent */
// The following classes are designed specifically for MessageBird API
export class SMSBalance{
	payment: string;
	type: string;
	amount: number;

	constructor(payment: string, type: string, amount: number) {
		this.payment = payment;
		this.type = type;
		this.amount = amount;
	}
}

export class SMSMessage {
	originator: string;
	body: string;
	created: string;
	totalRecipients: number;
	totalRecipientsDelivered: number;
	firstRecipientPhoneNumber: string;
	status: string;

	constructor(originator: string, body: string, created: string, totalRecipients: number,	totalRecipientsDelivered: number,	firstRecipientPhoneNumber: string, status: string) {
		this.originator = originator;
		this.body = body;
		this.created = created;
		this.totalRecipients = totalRecipients;
		this.totalRecipientsDelivered = totalRecipientsDelivered;
		this.firstRecipientPhoneNumber = firstRecipientPhoneNumber;
		this.status = status;
	}
}

export class SMSPredefined {
	id: number;
	body: string;

	constructor(id: number, body: string) {
		this.id = id;
		this.body = body;
	}
}



